import React from 'react'
import * as styles from "./styles/imageholder.module.css";
import { Image } from 'semantic-ui-react';

const ImageHolder = (props) => {
    const { heightToWidthRatio, imageHolderClassname = "", imageLoading = false, displayMode = "default", ...imageProps } = props;

    // heightToWidthRatio = (Height / Width)
    // Padding Bottom Percentage = heightToWidthRatio * 100
    // E.g. (400 / 500) * 100 = 80%
    const paddingBottomPercentage = `${(heightToWidthRatio * 100).toFixed(2)}%`;

    const handleImageError = (e) => {
        e.target.onError = null;
        e.target.src = "https://cdn.ngnw.ph/logo-product.png"
        e.target.className = `${props.className} ${styles.imageLoading}`
    }
    
    return (
        <div className={`${styles.imageHolder} ${imageHolderClassname}`} style={{paddingBottom: paddingBottomPercentage}}>
            {displayMode === "default" && <Image {...imageProps} onError={handleImageError}/> }
            {displayMode === "loading" && 
                <Image {...imageProps} src="https://cdn.ngnw.ph/loading-square.gif" className={`${props.className} ${styles.imageLoading}`}/>
            }

            {/* other display mode... */}
        </div>
    )
}

export default ImageHolder